// Package imports:
import { useMemo } from "react";
// Service imports:
import { _for } from "./utils";
// Type imports:
import { ByTradingDay, Requested } from "../types/api/Types";


export const useRequestedDataByDate = <T extends unknown>(
    dataByDate: ByTradingDay<Requested<T[]>>,
    currentTradingDay: string | undefined,
    dayRange?: {
        fromDate: string,
        toDate: string
    }
): [T[], boolean, boolean] => {
    const { data, isError, isLoading } = useMemo(() => {
        const data: Array<T> = [];
        let isLoading = false;
        let isError = false;
    
        // Single Day.
        if (currentTradingDay !== undefined) {
            const requestedData = dataByDate[currentTradingDay];
            if (requestedData === undefined || requestedData === 'waiting') {
                isLoading = true;
            } else if (requestedData instanceof Error) {
                isError = true;
            } else {
                if (Array.isArray(requestedData)) {
                    data.push(...requestedData);
                }
            }
        }
        // Day range.
        else if (dayRange !== undefined) {
            const { fromDate, toDate } = dayRange;
            _for(fromDate, toDate, (currentDate) => {
                const requestedData = dataByDate[currentDate];
                if (requestedData === undefined || requestedData === 'waiting') {
                    isLoading = true;
                    return 'break';
                }
                else if (requestedData instanceof Error) {
                    isError = true;
                    return 'break';
                } else {
                    if (Array.isArray(requestedData)){
                        data.push(...requestedData);
                    }
                }
            });
        }

        return {
            data,
            isError,
            isLoading
        }
    }, [ dataByDate, currentTradingDay, dayRange ]);

    return [data, isLoading, isError];
}
